module.exports = __webpack_public_path__ + "img/00024.f5e14f39.webp";